module.exports = __webpack_public_path__ + "img/bgImgLogin.5fa8bf33.svg";